import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Container } from 'app/models/container.model';
import { User } from 'app/models/user.model';
import { ContainerService } from 'app/services/container.service';
import { SimulationService } from 'app/services/simulation.service';
import { ToasterService } from 'app/services/user-interaction/services/toaster.service';
import { BaseFormComponent } from "../../base-form.component";

@Component({
    selector: "mia-marker-form",
    templateUrl: "./marker-form.component.html",
    styleUrls: ["./marker-form.component.css"]
})

export class MarkerFormComponent extends BaseFormComponent implements OnInit {

    /** */
    @Output() public close = new EventEmitter();
    @Output() public done = new EventEmitter();

    public companyId: number
    public get model(): any {
        return this._data;
    }

    private _containerList: Array<Container> = [];
    public get containerList(): Array<Container> {
        return this._containerList;
    }

    private _selectedContainer: Container;
    public get selectedContainer(): Container {
        return this._selectedContainer;
    }
    public set selectedContainer(v: Container) {
        this._selectedContainer = v;
    }

    constructor(
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _toasterService: ToasterService,
        private _simulationService: SimulationService,
        private _translateService:TranslateService,
        private _dialogRef: MatDialogRef<MarkerFormComponent>) {
        super();
    }


    public async ngOnInit(): Promise<void> {

        try {
            this.companyId =  parseInt(localStorage.getItem("CompanyID"))
            this._containerList = await this._simulationService.getContainers(this.companyId);
        } catch (error) {
            console.warn(error);

        }
    }


    public async save(): Promise<void> {
        if (!this._selectedContainer) {
            this._toasterService.toastWarning(this._translateService.instant("PLEASE_SELECT_CONTAINER"));
            return;
        }

        try {
            this.selectedContainer.latitude = this._data.lat;
            this.selectedContainer.longitude = this._data.lng;
            this.selectedContainer.status = true;
            this.selectedContainer.simulation=true;
            this._simulationService.updatedContainer(this.selectedContainer);
            this._dialogRef.close();
            this.done.emit();
        } catch (ex) {
            this.close.emit(ex);
        }
    }

    public cancel() {
        this._dialogRef.close();
        this.close.emit("");
    }


}




